'use strict';
/**
 * @doc module
 * @name chatFactory
 * @description
 *
 * chat API's
 */

var app = angular.module('harriApp');


app.factory('chatAPI', ["httpHelper", "asyncGlobalHandler", "$rootScope", "$interval", "hUser", function (httpHelper, asyncGlobalHandler, $rootScope, $interval, hUser) {

    var chatAPI = {
        lastCheck: 0
    };

    /**
     * Get Messages
     * @param app_id
     * @returns {HttpPromise|*}
     */
    chatAPI.getMessages = function (app_id) {

        var deferred  = $q.defer();
        if( app_id ){
            var result = httpHelper.g('application_messages/' + app_id).then(function(data){
                deferred.resolve(data.data);
            }, function(err){
                deferred.reject(err);
            });
            asyncGlobalHandler.watchPromise(result);

        }
        else{
            deferred.reject({'error':'Error in chat messages: please pass valid app_id.'});
        }

        return deferred.promise;
    };


    /**
     * Send Message
     *
     * @param m
     * @param app_id
     * @returns {*|HttpPromise}
     */
    chatAPI.sendMessage = function (m, app_id) {
        var result = httpHelper.put('application_messages', {
            "application_id": app_id,
            "message_body": m
        });
        asyncGlobalHandler.watchPromise(result);
        return result;
    };

    /**
     * Get New Msgs
     *
     * @param app_id
     * @param last_msg_id
     * @returns {HttpPromise|*}
     */
    chatAPI.getNewMsgs = function (app_id, last_msg_id) {
        var result = CoreReaderAPI.getAppMsgsUpdates(app_id, last_msg_id);
        asyncGlobalHandler.watchPromise(result);
        return result;
    };

    /**
     * Get All Notf for Employer
     *
     * @param app_id
     * @param last_msg_id
     * @returns {HttpPromise|*}
     */
    chatAPI.getEmpAllNotf = function (groupId) {
       var result = CoreReaderAPI.getEmployeeAllNotification(groupId);
        chatAPI.lastCheck = Date.now();
        return result;
    };

    /**
     * Get All Notf for Candidate
     *
     * @param app_id
     * @param last_msg_id
     * @returns {HttpPromise|*}
     */
    chatAPI.getCandAllNotf = function () {
        var result = httpHelper.g('unread_message_count_candidate');
        chatAPI.lastCheck = Date.now();
        return result;
    };


    /**
     * Get App Msgs Count
     *
     * @returns {HttpPromise|*}
     */
    chatAPI.getAppMsgsCount = function () {
        var result = httpHelper.g('application_message_counts');
//        asyncGlobalHandler.watchPromise(result);
        return result;
    };

    /**
     * Set Msgs As Read
     *
     * @param msgs
     * @param sender_type
     * @returns {*}
     */
    chatAPI.setMessagesAsRead = function (msgs, sender_type) {
        var ids_read = [];
        _.each(msgs, function (msg) {
            if (!msg.is_read && msg.sender_type == sender_type) {
                ids_read.push({
                    'message_id': msg.id,
                    'is_read': true
                });
            }
        });

        if (ids_read.length > 0) {
            var result = httpHelper.p('message_is_read', ids_read);
            asyncGlobalHandler.watchPromise(result);
            return result;
        }
        else {
            return false;
        }
    };


    /**
     * Get Emp App
     * @param offset
     * @param limit
     * @optional brandId
     * @returns {*|HttpPromise}
     */
    chatAPI.getEmpApp = function (offset, limit, brandId, includeArchived) {

        brandId = brandId || false;

        var apiUrl = 'employer_applications?offset=' + offset + '&limit=' + limit;

        if( brandId ){
          apiUrl += '&brand='+brandId;
        }
        if (includeArchived) {
            apiUrl += '&include_archived=true';
        }

        var result = httpHelper.g(apiUrl);
        asyncGlobalHandler.watchPromise(result);
        return result;
    };


    /**
     * Get Employer Brands with messages count
     */
    chatAPI.getEmpBrands = function(groupId, includeArchived) {
    var optionalParameter = '';

    if (includeArchived) {
        optionalParameter = '?include_archived=true';
    }
      var result = httpHelper.g('groups/' + groupId + '/employer/message_baord_data'+ optionalParameter);
      asyncGlobalHandler.watchPromise(result);
      return result;
    }


    /**
     * Get Cand App
     * @param offset
     * @param limit
     * @returns {*|HttpPromise}
     */
    chatAPI.getCandApp = function (offset, limit) {
        var result = httpHelper.g('candidate_applications?offset=' + offset + '&limit=' + limit);
        asyncGlobalHandler.watchPromise(result);
        return result;
    };


    /**
     * Get App Updates
     * @param offset
     * @param limit
     * @returns {*|HttpPromise}
     */
    chatAPI.getMsgsUpdate = function (application_id, message_id) {
        var result = CoreReaderAPI.getAppMsgsUpdates(application_id, message_id);
        asyncGlobalHandler.watchPromise(result);
        return result;
    };


    /**
     * Get App Updates
     * @param offset
     * @param limit
     * @returns {*|HttpPromise}
     */
    chatAPI.getNewEmpApp = function (last_date, brand_id) {

        brand_id = brand_id || false;

        var requestParams = {
          'last_date' : last_date
        };

        if( brand_id ){
          requestParams.brand = brand_id;
        }


        var result = httpHelper.p('employer_applications', requestParams);
        asyncGlobalHandler.watchPromise(result);
        return result;
    };


    var last_seen = null;
    chatAPI.getAppsUpdate = function (afterDate, isEmployer,brand_id, includeArchived) {
        var result;

        if (isEmployer) {

            brand_id = brand_id || false;

            var requestParams = {
              'last_date': afterDate
            };

            if(brand_id){
              requestParams.brand = brand_id;
            }

            if (includeArchived) {
                requestParams.include_archived = includeArchived;
            }

            result = httpHelper.p('employer_applications', requestParams);
        }
        else {
            result = httpHelper.p('candidate_applications', {
                'last_date': afterDate
            });
        }
        result.then(function (resp) {
            var new_apps = resp.data.data
            if (new_apps.length > 0) {
                last_seen = afterDate;
                $rootScope.$broadcast('chatNewAppsUpdates', new_apps);
            }
        });

    };

    /**
     * Get Employer Brands New Messages
     */
    chatAPI.getBrandsUpdates = function(groupId, includeArchived){
      var result = CoreReaderAPI.getBrandsUpdates(groupId, includeArchived);
      asyncGlobalHandler.watchPromise(result);
      return result;
    }

    chatAPI.getUpdates = function(isEmployer){
        var result;
        if (isEmployer) {
            result = chatAPI.getEmpAllNotf(hUser.getUserContext().brand_id);
        }
        else {
            result = chatAPI.getCandAllNotf();
        }

        return result;
    };

    return chatAPI;
}]);
